"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeAddress = exports.replaceQuotationMarks = exports.removeDiacriticsInAddress = exports.normalizeShippingAddress = exports.abbreviateMilitaryStateIfNeeded = exports.abbreviateMilitaryCityIfNeeded = exports.abbreviateToMilitaryCodesIfNeeded = exports.abbreviateToInternationalCodesIfNeeded = exports.abbreviateToStateCodeIfNeeded = exports.addressToFormattedString = exports.doesAddressContainPOBox = exports.doesAddressContainNonAsciiCharacters = exports.sanitizeName = exports.removeNewLineInAddress = exports.trimWhitespaceInAddress = exports.doesAddressRequireCustomsInfo = exports.isInternationalAddress = exports.isDomesticMilitaryAddress = exports.isInternationalMilitaryAddress = exports.isMilitaryAddress = exports.DOMESTIC_MILITARY_CITIES = exports.OVERSEAS_MILITARY_CITIES = exports.MILITARY_STATES = exports.isAddressInAkHiOther = exports.correctUSTerritories = exports.INTERNATIONAL_COUNTRY_CODES = exports.INTERNATIONAL_COUNTRIES_AND_STATES_MAP = exports.CA_PROVINCES = exports.INTERNATIONAL_COUNTRIES = exports.US_STATES_AND_TERRITORIES = exports.US_STATES = exports.US_TERRITORIES = void 0;
const _ = require("lodash");
const commons_objects_1 = require("@deliverr/commons-objects");
const EnvUtils_1 = require("./EnvUtils");
const leven_1 = require("leven");
const levenary_1 = require("levenary");
const lib_1 = require("@deliverr/commons-logs/lib");
const STATE_LEVEN_THRESHOLD = (0, EnvUtils_1.getEnvNumber)("STATE_LEVEN_THRESHOLD", 2);
const INTERNATIONAL_LEVEN_THRESHOLD = (0, EnvUtils_1.getEnvNumber)("INTERNATIONAL_LEVEN_THRESHOLD", 2);
const MILITARY_STATE_LEVEN_THRESHOLD = (0, EnvUtils_1.getEnvNumber)("MILITARY_STATE_LEVEN_THRESHOLD", 3);
const OVERSEAS_MILITARY_CITY_LEVEN_THRESHOLD = (0, EnvUtils_1.getEnvNumber)("MILITARY_CITY_LEVEN_THRESHOLD", 2);
exports.US_TERRITORIES = {
    "PUERTO RICO": "PR",
    GUAM: "GU",
    "AMERICAN SAMOA": "AS",
    "NORTHERN MARIANA ISLANDS": "MP",
    "US VIRGIN ISLANDS": "VI",
    "DISTRICT OF COLUMBIA": "DC",
};
exports.US_STATES = {
    ALABAMA: "AL",
    ALASKA: "AK",
    ARIZONA: "AZ",
    ARKANSAS: "AR",
    CALIFORNIA: "CA",
    COLORADO: "CO",
    CONNECTICUT: "CT",
    DELAWARE: "DE",
    FLORIDA: "FL",
    GEORGIA: "GA",
    HAWAII: "HI",
    IDAHO: "ID",
    ILLINOIS: "IL",
    INDIANA: "IN",
    IOWA: "IA",
    KANSAS: "KS",
    KENTUCKY: "KY",
    LOUISIANA: "LA",
    MAINE: "ME",
    MARYLAND: "MD",
    MASSACHUSETTS: "MA",
    MICHIGAN: "MI",
    MINNESOTA: "MN",
    MISSISSIPPI: "MS",
    MISSOURI: "MO",
    MONTANA: "MT",
    NEBRASKA: "NE",
    NEVADA: "NV",
    "NEW HAMPSHIRE": "NH",
    "NEW JERSEY": "NJ",
    "NEW MEXICO": "NM",
    "NEW YORK": "NY",
    "NORTH CAROLINA": "NC",
    "NORTH DAKOTA": "ND",
    OHIO: "OH",
    OKLAHOMA: "OK",
    OREGON: "OR",
    PENNSYLVANIA: "PA",
    "RHODE ISLAND": "RI",
    "SOUTH CAROLINA": "SC",
    "SOUTH DAKOTA": "SD",
    TENNESSEE: "TN",
    TEXAS: "TX",
    UTAH: "UT",
    VERMONT: "VT",
    VIRGINIA: "VA",
    WASHINGTON: "WA",
    "WEST VIRGINIA": "WV",
    WISCONSIN: "WI",
    WYOMING: "WY",
};
exports.US_STATES_AND_TERRITORIES = Object.assign(Object.assign({}, exports.US_STATES), exports.US_TERRITORIES);
exports.INTERNATIONAL_COUNTRIES = {
    CANADA: "CA",
};
exports.CA_PROVINCES = {
    ONTARIO: "ON",
    QUEBEC: "QC",
    "NOVA SCOTIA": "NS",
    "NEW BRUNSWICK": "NB",
    MANITOBA: "MB",
    "BRITISH COLUMBIA": "BC",
    "PRINCE EDWARD ISLAND": "PE",
    SASKATCHEWAN: "SK",
    ALBERTA: "AB",
    "NEWFOUNDLAND AND LABRADOR": "NL",
};
exports.INTERNATIONAL_COUNTRIES_AND_STATES_MAP = {
    CA: exports.CA_PROVINCES,
};
exports.INTERNATIONAL_COUNTRY_CODES = Object.values(commons_objects_1.CountryCodeLookup).filter((code) => !["US", ...Object.values(exports.US_TERRITORIES)].includes(code));
const correctUSTerritories = (address) => {
    const formattedCountry = address.country.toUpperCase();
    const hasMatchingTerritoryName = Object.keys(exports.US_TERRITORIES).includes(formattedCountry);
    if (hasMatchingTerritoryName) {
        return Object.assign(Object.assign({}, address), { state: exports.US_TERRITORIES[formattedCountry], country: "US" });
    }
    const hasMatchingTerritoryAbbr = Object.values(exports.US_TERRITORIES).includes(formattedCountry);
    return hasMatchingTerritoryAbbr
        ? Object.assign(Object.assign({}, address), { state: formattedCountry, country: "US" }) : address;
};
exports.correctUSTerritories = correctUSTerritories;
const akHiOtherZip3 = [
    "006",
    "007",
    "008",
    "009",
    "090",
    "091",
    "092",
    "093",
    "094",
    "095",
    "096",
    "097",
    "098",
    "962",
    "963",
    "964",
    "965",
    "966",
    "967",
    "968",
    "969",
    "995",
    "996",
    "997",
    "998",
    "999",
];
const isAddressInAkHiOther = (address) => {
    const correctedAddress = (0, exports.correctUSTerritories)(address);
    return (Boolean(correctedAddress.zip) &&
        akHiOtherZip3.includes(correctedAddress.zip.substr(0, 3)) &&
        (correctedAddress.country === "US" || (0, exports.isMilitaryAddress)(correctedAddress)));
};
exports.isAddressInAkHiOther = isAddressInAkHiOther;
exports.MILITARY_STATES = {
    "ARMED FORCES AMERICAS": "AA",
    "ARMED FORCES EUROPE": "AE",
    "ARMED FORCES PACIFIC": "AP",
};
exports.OVERSEAS_MILITARY_CITIES = {
    "ARMY POST OFFICE": "APO",
    "FLEET POST OFFICE": "FPO",
    "DIPLOMATIC POST OFFICE": "DPO",
};
exports.DOMESTIC_MILITARY_CITIES = ["AFB", "AIR FORCE BASE"];
const isMilitaryAddress = (address) => {
    return (0, exports.isInternationalMilitaryAddress)(address) || (0, exports.isDomesticMilitaryAddress)(address);
};
exports.isMilitaryAddress = isMilitaryAddress;
const isInternationalMilitaryAddress = (address) => {
    return ((Boolean(address.state) && Object.values(exports.MILITARY_STATES).includes(address.state.trim().toUpperCase())) ||
        (Boolean(address.city) && Object.values(exports.OVERSEAS_MILITARY_CITIES).includes(address.city.trim().toUpperCase())));
};
exports.isInternationalMilitaryAddress = isInternationalMilitaryAddress;
const isDomesticMilitaryAddress = (address) => {
    return (!(0, exports.isInternationalMilitaryAddress)(address) &&
        Boolean(address.country) &&
        address.country.trim().toUpperCase() === "US" &&
        Boolean(address.city) &&
        exports.DOMESTIC_MILITARY_CITIES.some((element) => {
            return address.city.trim().toUpperCase().includes(element);
        }));
};
exports.isDomesticMilitaryAddress = isDomesticMilitaryAddress;
const isInternationalAddress = (validatedAddress) => {
    return validatedAddress.country !== "US";
};
exports.isInternationalAddress = isInternationalAddress;
const doesAddressRequireCustomsInfo = (validatedAddress) => {
    return (["GU", "AS", "MP", "FM"].includes(validatedAddress.state) ||
        (0, exports.isInternationalAddress)(validatedAddress) ||
        (0, exports.isInternationalMilitaryAddress)(validatedAddress));
};
exports.doesAddressRequireCustomsInfo = doesAddressRequireCustomsInfo;
const trimWhitespaceInAddress = (address) => {
    return _.mapValues(address, (value) => (typeof value === "string" ? value.trim() : value));
};
exports.trimWhitespaceInAddress = trimWhitespaceInAddress;
const removeNewLineInAddress = (address) => {
    return _.mapValues(address, (value) => typeof value === "string" ? value.replace(/\n/g, "") : value);
};
exports.removeNewLineInAddress = removeNewLineInAddress;
const sanitizeName = (address) => {
    const cleanName = address.name.replace(/[,~`@#$%^&*+=?;[{\]}]/g, "");
    const trimmedName = cleanName.replace(/\s+/g, " ").trim();
    return Object.assign(Object.assign({}, address), { name: trimmedName });
};
exports.sanitizeName = sanitizeName;
const doesAddressContainNonAsciiCharacters = (address) => {
    return /[^\x20-\x7E]/.test([address.name, address.street1, address.street2, address.city, address.state, address.zip, address.country]
        .join(" ")
        .toLowerCase());
};
exports.doesAddressContainNonAsciiCharacters = doesAddressContainNonAsciiCharacters;
const doesAddressContainPOBox = (address) => {
    return /p\.?\s{0,3}o\.?\s{0,3}(box\s{0,3}\d+|\d+\s{0,3}box)/.test([address.street1, address.street2].join(" ").toLowerCase());
};
exports.doesAddressContainPOBox = doesAddressContainPOBox;
const addressToFormattedString = (address) => {
    var _a;
    const res = [address.street1, address.street2, address.city, (_a = address.zip) === null || _a === void 0 ? void 0 : _a.substring(0, 5)]
        .filter((field) => !_.isUndefined(field))
        .join(" ");
    return res.toLowerCase();
};
exports.addressToFormattedString = addressToFormattedString;
const abbreviateToStateCodeIfNeeded = (address) => {
    const formattedStateOrTerritory = address.state.toUpperCase().trim();
    const formattedCountry = address.country.toUpperCase().trim();
    const ctx = { fn: "abbreviateToStateCodeIfNeeded", address };
    if (Object.values(exports.US_STATES_AND_TERRITORIES).includes(formattedStateOrTerritory) &&
        !exports.INTERNATIONAL_COUNTRY_CODES.includes(formattedCountry)) {
        lib_1.log.info(Object.assign(Object.assign({}, ctx), { state: formattedStateOrTerritory, country: formattedCountry }), "state matches US state or territory - changing country to US");
        return Object.assign(Object.assign({}, address), { state: formattedStateOrTerritory, country: "US" });
    }
    const nameMatch = (0, levenary_1.default)(formattedStateOrTerritory, Object.keys(exports.US_STATES_AND_TERRITORIES));
    const stateLeven = (0, leven_1.default)(formattedStateOrTerritory, nameMatch);
    if (stateLeven <= STATE_LEVEN_THRESHOLD && !exports.INTERNATIONAL_COUNTRY_CODES.includes(formattedCountry)) {
        lib_1.log.info(Object.assign(Object.assign({}, ctx), { country: formattedCountry, state: formattedStateOrTerritory, nameMatch,
            stateLeven,
            STATE_LEVEN_THRESHOLD }), "state meets STATE_LEVEN_THRESHOLD - changing country to US");
        return Object.assign(Object.assign({}, address), { state: exports.US_STATES_AND_TERRITORIES[nameMatch], country: "US" });
    }
    return address;
};
exports.abbreviateToStateCodeIfNeeded = abbreviateToStateCodeIfNeeded;
const abbreviateToInternationalCodesIfNeeded = (address) => {
    const formattedState = address.state.toUpperCase().trim();
    const formattedCountry = address.country.toUpperCase().trim();
    if (Object.values(exports.INTERNATIONAL_COUNTRIES).includes(formattedCountry) &&
        Object.values(exports.INTERNATIONAL_COUNTRIES_AND_STATES_MAP[formattedCountry]).includes(formattedState)) {
        return Object.assign(Object.assign({}, address), { state: formattedState, country: formattedCountry });
    }
    const countryNameMatch = (0, levenary_1.default)(formattedCountry, Object.keys(exports.INTERNATIONAL_COUNTRIES));
    if ((0, leven_1.default)(formattedCountry, countryNameMatch) <= INTERNATIONAL_LEVEN_THRESHOLD) {
        const abbreviatedCountry = exports.INTERNATIONAL_COUNTRIES[countryNameMatch];
        const states = exports.INTERNATIONAL_COUNTRIES_AND_STATES_MAP[abbreviatedCountry];
        if (Object.values(states).includes(formattedState)) {
            return Object.assign(Object.assign({}, address), { state: formattedState, country: abbreviatedCountry });
        }
        const stateNameMatch = (0, levenary_1.default)(formattedState, Object.keys(states));
        return (0, leven_1.default)(formattedState, stateNameMatch) <= INTERNATIONAL_LEVEN_THRESHOLD
            ? Object.assign(Object.assign({}, address), { state: states[stateNameMatch], country: abbreviatedCountry }) : address;
    }
    return address;
};
exports.abbreviateToInternationalCodesIfNeeded = abbreviateToInternationalCodesIfNeeded;
const abbreviateToMilitaryCodesIfNeeded = (address) => {
    const abbreviatedCityAddress = (0, exports.abbreviateMilitaryCityIfNeeded)(address);
    const fullyAbbreviatedAddress = (0, exports.abbreviateMilitaryStateIfNeeded)(abbreviatedCityAddress);
    return fullyAbbreviatedAddress;
};
exports.abbreviateToMilitaryCodesIfNeeded = abbreviateToMilitaryCodesIfNeeded;
const abbreviateMilitaryCityIfNeeded = (address) => {
    var _a;
    const formattedCity = (_a = address.city) === null || _a === void 0 ? void 0 : _a.toUpperCase().trim();
    if (Object.values(exports.OVERSEAS_MILITARY_CITIES).includes(formattedCity)) {
        return address;
    }
    if (Object.keys(exports.OVERSEAS_MILITARY_CITIES).includes(formattedCity)) {
        return Object.assign(Object.assign({}, address), { city: exports.OVERSEAS_MILITARY_CITIES[formattedCity] });
    }
    const cityNameMatch = (0, levenary_1.default)(formattedCity, Object.keys(exports.OVERSEAS_MILITARY_CITIES));
    const cityLeven = (0, leven_1.default)(formattedCity, cityNameMatch);
    if (cityLeven <= OVERSEAS_MILITARY_CITY_LEVEN_THRESHOLD) {
        return Object.assign(Object.assign({}, address), { city: exports.OVERSEAS_MILITARY_CITIES[cityNameMatch] });
    }
    return address;
};
exports.abbreviateMilitaryCityIfNeeded = abbreviateMilitaryCityIfNeeded;
const abbreviateMilitaryStateIfNeeded = (address) => {
    var _a;
    const formattedState = (_a = address.state) === null || _a === void 0 ? void 0 : _a.toUpperCase().trim();
    if (Object.values(exports.MILITARY_STATES).includes(formattedState)) {
        return address;
    }
    if (Object.keys(exports.MILITARY_STATES).includes(formattedState)) {
        return Object.assign(Object.assign({}, address), { state: exports.MILITARY_STATES[formattedState] });
    }
    const stateNameMatch = (0, levenary_1.default)(formattedState, Object.keys(exports.MILITARY_STATES));
    const stateLeven = (0, leven_1.default)(formattedState, stateNameMatch);
    if (stateLeven <= MILITARY_STATE_LEVEN_THRESHOLD) {
        return Object.assign(Object.assign({}, address), { state: exports.MILITARY_STATES[stateNameMatch] });
    }
    return address;
};
exports.abbreviateMilitaryStateIfNeeded = abbreviateMilitaryStateIfNeeded;
const normalizeShippingAddress = (address) => {
    const abbreviatedMilitaryAddress = (0, exports.abbreviateToMilitaryCodesIfNeeded)(address);
    if ((0, exports.isInternationalMilitaryAddress)(abbreviatedMilitaryAddress)) {
        return abbreviatedMilitaryAddress;
    }
    const territoryCorrectedAddress = (0, exports.correctUSTerritories)(address);
    const abbreviatedStateAddress = (0, exports.abbreviateToStateCodeIfNeeded)(territoryCorrectedAddress);
    return (0, exports.isInternationalAddress)(abbreviatedStateAddress)
        ? (0, exports.abbreviateToInternationalCodesIfNeeded)(abbreviatedStateAddress)
        : abbreviatedStateAddress;
};
exports.normalizeShippingAddress = normalizeShippingAddress;
const removeDiacriticsInAddress = (address) => {
    return _.mapValues(address, (value) => (typeof value === "string" ? _.deburr(value) : value));
};
exports.removeDiacriticsInAddress = removeDiacriticsInAddress;
const replaceQuotationMarks = (address) => {
    return _.mapValues(address, (value) => typeof value === "string" ? value.replace(/[`’]/g, "'") : value);
};
exports.replaceQuotationMarks = replaceQuotationMarks;
const sanitizeAddress = (address) => {
    return (0, exports.trimWhitespaceInAddress)((0, exports.sanitizeName)((0, exports.replaceQuotationMarks)((0, exports.removeDiacriticsInAddress)((0, exports.removeNewLineInAddress)(address)))));
};
exports.sanitizeAddress = sanitizeAddress;
//# sourceMappingURL=AddressUtils.js.map